export default __webpack_public_path__ + "static/media/sideMenu_podcast.679b4f08.svg";